module.exports = __webpack_public_path__ + "img/sunglasses.d492ef07.png";